var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 620,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1621,
    y: 795,
    width: 644,
    height: 620
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.486879,
    y: -6096.46,
    width: 3932261,
    height: 3792041
  })), /*#__PURE__*/React.createElement("image", {
    width: 55,
    height: 53,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA1CAMAAADSzYN/AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACNUExURQAAAJOTk5SUlJOTk5SUlJSUlJWVlZWVlZOTk5WVlZWVlZSUlJSUlJWVlZ+fn5eXl5SUlJSUlJWVlZSUlI+Pj5SUlJSUlJOTk5SUlJSUlJOTk5WVlZWVlaGhoZubm9fX1/////j4+KioqPLy8q+vr5WVlcPDw+vr67y8vLa2tpOTk+Tk5N3d3ZKSkpWVlbOECGAAAAAvdFJOUwAoWIC3v2AwUJff/+efCCD3pxiPEM/XQO9waIdI///////////H/////3j//zivDEKVMAAAAAlwSFlzAAAXEQAAFxEByibzPwAAAehJREFUSEudlul2gjAQRiMY2QW1dW0Vu2g3+/6P10n41GQIkNP7wzOZ5B4ChmGEk1EQhmNJhOEkQm6QOEkzk7wIppjqpiwqLLeY9V91vnBaiqLEmjbTbkuRPGAdo3zEgi6WI6y0WK0x3c06xlqDDeb6CbH6xhYTQ+ywHjwhPcwWhiYavrcr1RMcYm4fkH7W96c6Q4p4ttkjbSJhiQgJxaG2OL4gb3L9NyTGCuY5xcfmmMcYag71ARHxWh/r+g0Dg4323jHSMO90dom50koMGpj3sSfxE8M7K/K+EDdwL9t/1/TLSPg2216WkXhqxjdoo/Y2uXf+Ieix8q2uxAQRYN4VI6kJRYgIWN7HqeHc8gpRIAKWd6WdlGKMCHh6S8GKiqe3Fjki4OllYokAeHqV9TIQnl767+e5QwQ8vRmvm57eQlwQAU8vEMKuZX5eRZXCvkE/b0bvn71RP4+2yTbq5altsi+Rl7dQmpiaF/Tx8rn2rAJKdffYxvaa8kkY7xKv18D00ltXEt37gf2LG0wrjA9ZgJQPX3A0dvHtQ5VcA/Y6dTJmLdf0FxP9yHbvwwqpk+YPZ8RDzUGlj2WbUX+jtezuCeNuM51gjZvA3ZLkt7PVyWXBSmqWJsYR6aPcJlLqsydlsXF0j0L8ASYbgd7HDndgAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3922484,
    height: 3779848
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1621 -795)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000164028 0 0 0.000164028 1621 795)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1.00094 0 0 1 -0.848568 -0.485352)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(71317.9 71317.9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportNotification);
export default __webpack_public_path__ + "static/media/report-notification.c9452f00f0822d3ee9217f3831f7b2cc.svg";
export { ForwardRef as ReactComponent };